"use client";
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function ReaderAuthControl({ currentPrefix }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const pathname = usePathname();

  useEffect(() => {
    fetch('/api/reader/auth/session')
      .then(res => res.json())
      .then(data => {
        if (data.reader) setSession(data.reader);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleLogout = async () => {
    await fetch('/api/reader/auth/logout', { method: 'POST' });
    setSession(null);
    window.location.reload();
  };

  const prefixPath = currentPrefix ? `/${currentPrefix}` : '';
  const loginUrl = `${prefixPath}/reader/login?returnTo=${encodeURIComponent(pathname)}`;

  if (loading) return <span className="text-gray-400">...</span>;

  if (session) {
    return (
      <div className="relative group">
        <span className="cursor-pointer font-medium hover:underline flex items-center">
          {session.displayName} <span className="ml-1 text-[10px]">?</span>
        </span>
        <div className="absolute top-full right-0 mt-2 bg-white border border-gray-200 shadow-sm px-4 py-2 hidden group-hover:block z-50 whitespace-nowrap">
          <button onClick={handleLogout} className="text-sm text-gray-700 hover:text-black">
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  return (
    <Link href={loginUrl} className="cursor-pointer hover:underline font-medium">
      SIGN IN
    </Link>
  );
}
